module.exports = __webpack_public_path__ + "img/插图_加入我们_03@2x.deea1fc3.png";